import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Breadcrumb, Col, Row, Button } from 'react-bootstrap';
import Card from '../../UI/Card/Card';
import SecBTN from '../../UI/SecBTN';
import Select from '../../UI/Select/Select';
import classes from "./Myschedule.module.css";
import { useNavigate } from 'react-router-dom';
import Toast from '../../UI/Toast/Toast';
import userService from '../../app/services/user.service';
import Input from "../../UI/Input/Input";
import { useLocation } from 'react-router-dom';
import "./Homework.css";
import QuestionsCard from './QuestionsCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faStop } from '@fortawesome/free-solid-svg-icons';
import classes1 from "../PaperFormat/PaperFormat.module.css";
import { HomeworkPreview } from './HomeworkPreview';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import SuccessModal from '../../UI/SuccessModal/SuccessModal';
import { Modal, Form, InputGroup, FormControl } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import axios from 'axios';
import { toast } from 'react-toastify';

export const Homework = () => {
  const [show, setShow] = useState(true);
  const [mouduleData, setModuleData] = useState([]);
  const [selectedModule, setSelectedModule] = useState("")
  const [topicList, setTopicList] = useState([]);
  const [selectedtopic, setSelectedTopic] = useState("")
  const [dppExercise, setDppExercise] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState("Excercise-1");
  const [subTopicList, setSubTopicList] = useState([]);
  const [selectedSubTopic, setSelectedSubTopic] = useState("");
  const [homeworkquestions, setHomeworkquestions] = useState([]);
  const [selectedToughness, setSelectedToughtness] = useState([]);
  const [subtoicId, setSubtopicId] = useState(1);
  const [topicId, setTopicId] = useState(1);
  const [moduleId, setModuleId] = useState(1);
  const [tough_id, setToughId] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [questionRange, setQuestionRange] = useState("");
  const [inputRange, setInputRange] = useState("");
  const [toughness, setToughness] = useState("");
  const [rangelist, setRangeList] = useState([]);
  const [uncheckRange, setUncheckRange] = useState([]);
  const mediaRecorderRef = useRef(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const audioChunksRef = useRef([]);
  const [previewData, setPreviewData] = useState([]);
  const [totalquestions, setTotalQuestions] = useState(0);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);
  const [hours, setHours] = useState('07');
  const [minutes, setMinutes] = useState('00');
  const [ampm, setAmpm] = useState('AM');
  const [date, setDate] = useState("");
  const [showPopUp1,setShowPopUp1]=useState(false);
  const [showPopUp2,setShowPopUp2]=useState(false);
  

  const location = useLocation();
  const { facultyId, subjectId, batch, t_id, id,reqData } = location.state || {};

  reqData.homework_status="yes";
 
 

  useEffect(() => {
    getHomeworkModule();
    getHomeworkTopic();

    if (selectedModule) {
      const defaultTopic = topicList.find(topic => topic.is_selected === 1);
      console.log(defaultTopic);
      if (defaultTopic) {
        setSelectedTopic(defaultTopic.topic_name);
        setTopicId(defaultTopic.topic_id);
        getSubTopicList(defaultTopic.topic_id);
        getHomeworkDppExercise(defaultTopic.topic_id);
      }
    }
    GetReqQuetionList();
    getQestionToughness();
    getPreviewData();

  }, [selectedModule]);


  useEffect(() => {

   
    if (selectedtopic) {
      getSubTopicList(topicId);
      getHomeworkDppExercise(topicId);
      
      GetReqQuetionList();
      setSelectedSubTopic("");
      setSelectedExercise("");
    }
  }, [selectedtopic]);


  useEffect(() => {

    if (selectedSubTopic || selectedExercise) {
      GetReqQuetionList();
    }
    getPreviewData();
  }, [selectedSubTopic, selectedExercise, toughness]);


  useEffect(() => {
    let timer;
    if (isRecording) {
      // Start the timer if recording is active
      timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 1);
      }, 1000);
    } else {
      // Reset the timer when recording stops
      setSeconds(0);
    }
    return () => clearInterval(timer);
  }, [isRecording]);

  const getHomeworkModule = () => {
    userService.homeworkModule()
      .then(res => {
        setModuleData(res.data.data);

      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
  };
  const getSubTopicList = (topicId) => {
    console.log("Topic Id ",topicId);
    userService.subTopicList(topicId,moduleId,facultyId,subjectId,batch)
      .then(res => {
        setSubTopicList(res.data.data);
        setSubtopicId(res.data.data[0]?.sub_topic_id)
        console.log(res.data.data);
      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });


  };

  const getHomeworkTopic = () => {
    userService.homeworkTopicList(subjectId, batch, t_id,facultyId,moduleId)
      .then(res => {
        setTopicList(res.data.data);
        console.log(res.data.data);

      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
  };

  const getHomeworkDppExercise = (topicId) => {
    console.log(moduleId);
    userService.homeworkDppExercise(topicId, facultyId, batch,moduleId)
      .then(res => {
        setDppExercise(res.data.data);

      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
  };

  const GetReqQuetionList = () => {

    userService.reqQuestionList(facultyId, subjectId, topicId, subtoicId, batch, moduleId, selectedExercise, tough_id)
      .then(res => {
        setHomeworkquestions(res.data.data);
        // console.log(res.data.data);
      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });

  }
  const getQestionToughness = () => {
    userService.QuestionToughness()
      .then(res => {
        setSelectedToughtness(res.data.data);
        // console.log(res.data.data)


      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
  };

  const getPreviewData = () => {
    userService.PreviewList(moduleId, facultyId, batch, subtoicId, subjectId)
      .then(res => {
        setPreviewData(res.data.data);
        setTotalQuestions(res.data.total_all_questions);
        // console.log(res.data.data);
      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
  };


  // Handler for SubTopics
const subTopicHandler = (subtopic) => {
  setSelectedSubTopic(subtopic); // Set the selected subtopic name
  const selectedsubTopicObj = subTopicList.find(t => t.sub_topic_name === subtopic);
  if (selectedsubTopicObj) {
    setSubtopicId(selectedsubTopicObj.sub_topic_id); // Set the subtopic ID
  }
};

// Handler for Exercises
const exerciseHandler = (exercise) => {
  setSelectedExercise(exercise); // Set the selected exercise type
  const selectedExerciseObj = dppExercise?.find(t => t.excersie_type === exercise);
  if (selectedExerciseObj) {
    setSubtopicId(selectedExerciseObj.sub_topic_id); // Set the subtopic ID if linked to an exercise
  }
};


  const modulehandler = (module) => {
    setSelectedModule(module);
    const selectedTopicObj = mouduleData.find(t => t.name === module);
    if (selectedTopicObj) {
      setModuleId(selectedTopicObj.module_id);
    }
  }

  const topicHandler = (topic) => {
    setSelectedTopic(topic);
    const selectedTopicObj = topicList.find(t => t.topic_name === topic);
    if (selectedTopicObj) {
      setTopicId(selectedTopicObj.topic_id);
    }

  };

  const Toughnesshandler = (toughness) => {
    setToughness(toughness);
    const selectedTough = selectedToughness.find(t => t.toughness === toughness);
    if (selectedTough) {
      setToughId(selectedTough.toughness_id);
    }
    
  }

  const startRecording = async () => {
    setIsRecording(true);
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);
    mediaRecorderRef.current.ondataavailable = (event) => {
      audioChunksRef.current.push(event.data);
    };
    mediaRecorderRef.current.start();
  };

  const stopRecording = () => {
    setIsRecording(false);
    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.onstop = () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play(); // Play
    };
    audioChunksRef.current = [];
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const handleRangeChange = (e) => {
    setQuestionRange(e.target.value); // Update the input range
  };

  const convertRangeToArray = (range) => {
    const [start, end] = range.split('-').map(Number); // Convert "1-5" into [1, 5]
    const array = [];
    for (let i = start; i <= end; i++) {
      array.push(i);
    }
    return array;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default Enter behavior

      // Regular expression to validate the format strictly as "number-number"
      const rangePattern = /^(\d+)\s*-\s*(\d+)$/;
      const match = questionRange.match(rangePattern);

      if (match) {
        const firstNumber = parseInt(match[1], 10);
        const secondNumber = parseInt(match[2], 10);

        // Ensure the first number is smaller than the second
        if (firstNumber < secondNumber) {
          // Set the inputRange to the validated question range
          setInputRange(questionRange);

          // Append the new range array to the existing rangeList
          setRangeList((prevRangeList) => [...prevRangeList, [firstNumber, secondNumber]]);

          // Clear the input field after appending
          setQuestionRange("");


        } else {
          alert("The first number should be smaller than the second number.");
        }
      } else {
        alert("Invalid format. Please use the correct format (e.g., 1-5 or 12-24), with only numbers and a hyphen.");
      }

    }
  };

  const HandlePreview = () => {



    const preview_data = {
      module_id: moduleId,
      topic_id: topicId,
      faculty_id: facultyId,
      batch: batch,
      sub_topic_id: "",
      subject_id: subjectId
    }


    // navigate("./preview", { state: { preview_data: preview_data } });
  }

  const handleRemoveRange = (index) => {


    const uncheck_range = rangelist[index];
    setUncheckRange(uncheck_range);
    const updatedRangeList = rangelist.filter((_, idx) => idx !== index);
    setRangeList(updatedRangeList);
  };


  const onHideHandler = () => {
    setShowPopUp(false);
    setShowPopUp1(false);
    setShowPopUp2(false);
  }
  const yesHandler = () => {
     setShowPopUp(false);
     setShowPopUp1(true);
  }
  const noHandler = () => {
    setShowPopUp(false);
  }

  const handleDateChange = (date) => {



    const formattedDate = date.toLocaleDateString("en-IN", {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    setDate(formattedDate);
    setSelectedDate(date);

  };

  const handleHour = (hour) => {
    setHours(hour);
  }
  const handleMinutes = (minute) => {
    setMinutes(minute);
  }
  const handleAmPm = (AP) => {
    setAmpm(AP);
  }


  const addCourseReport = () => {
    console.log("Report Submitted");
    userService
      .addCourseReport(reqData)
      .then((res) => {
        console.log(res);
        if (res.data === true) {
        
          toast.success("Report Added Successfully.");
          setShow(false);
        } else {
          toast.error("Something went wrong!");
          setShow(false);
        }
        if (res.msg == "Course Report Successfully Submited") {
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!");
      });
    
  };



  const handleHomeworkSubmit = () => {
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    const scheduleTime = date + " " + formattedTime;
    

    const selectedModuleIds = previewData.map(module => module.id);
    

    const payload = {
      faculty_id: facultyId,
      batch: batch,
      subject_id: subjectId,
      faculty_schedule_id: id,
      submission_time: scheduleTime,
      id: selectedModuleIds,
      
    };
    
      
    
    axios.post('https://learning.motion.ac.in/motioneducation/api/v1/homework_questions_assign', payload)
      .then((response) => {
        console.log('Success:',response.data);
        setShowPopUp1(false);
        setShowPopUp2(true);
        addCourseReport();
      })
      .catch((error) => {
        console.error('Error:', error); 
      });
    setShowPopUp1(false);
    setShowPopUp2(true);
   
  }

  const onSubmitHandler=()=>{

    navigate('/schedule');
  }

  return (
    <>
      <Toast />
      <div className="d-flex page-head justify-content-between align-items-center">
        <div>
          <h4>My Schedule</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>  My Schedule</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {"Homework"}
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item> */}
          </Breadcrumb>
        </div>

        <SecBTN className={classes["sec-btn2"]} onClick={() => setShowPopUp(true)}>Assign</SecBTN>

      </div>

      <ConfirmationModal
        title="Do You Want to Assign Homework"
        show={showPopUp}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        noHandler={noHandler}

        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onSubmitHandler}
        title="Homework Assigned Successfully!"
        btnTxt="Ok"
      />

      <Modal show={showPopUp1} onHide={onHideHandler}>
        <Modal.Header closeButton>
          <h4>Select Date and Time</h4>
        </Modal.Header>
        <Modal.Body>
          {/* Calendar Date Picker */}
          <Form.Group>
            <Form.Label>Select Date</Form.Label>
            <InputGroup>
              <FormControl
                as={DatePicker}
                selected={selectedDate}
                onChange={e => handleDateChange(e)}
                dateFormat="dd/MM/yyyy"
                className="form-control" // Bootstrap class for input styling
                placeholderText="Select a date"
              />

            </InputGroup>
          </Form.Group>

          {/* Time Picker using react-bootstrap */}
          <Form.Group>
            <Form.Label>Select Time</Form.Label>
            <Row>
              <Col>
                {/* Hours */}
                <Form.Control
                  as="select"
                  value={hours}
                  onChange={(e) => {
                    handleHour(e.target.value);

                  }}
                >
                  {Array.from({ length: 12 }, (_, i) => {
                    const hour = i + 1 < 10 ? `0${i + 1}` : i + 1;
                    return <option key={hour} value={hour}>{hour}</option>;
                  })}
                </Form.Control>
              </Col>
              <Col>
                {/* Minutes */}
                <Form.Control
                  as="select"
                  value={minutes}
                  onChange={(e) => {
                    handleMinutes(e.target.value);
                  }}
                >
                  {Array.from({ length: 60 }, (_, i) => {
                    const minute = i < 10 ? `0${i}` : i;
                    return <option key={minute} value={minute}>{minute}</option>;
                  })}
                </Form.Control>
              </Col>
              <Col>
                {/* AM/PM */}
                <Form.Control
                  as="select"
                  value={ampm}
                  onChange={(e) => {
                    handleAmPm(e.target.value);

                  }}
                >
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
        </Modal.Body>

        <div className='assign'>
          <SecBTN className={`${classes1.activate}`} onClick={handleHomeworkSubmit}>Assign </SecBTN>
        </div>
      </Modal>

      {
        previewData &&
        <HomeworkPreview previewData={previewData} />
      }
      <Card className={`${classes.filter} datafilter-container`}>
        <Row>
          <Col lg={6} md={6} sm={12} className="my-1">
            <Select
              value={selectedModule}
              onChange={(e) => {
                modulehandler(e.target.value)
                // getTopicList(e.target.value);
              }}
            >
              <option value="" disabled>
                Select Module
              </option>
              {mouduleData.map((subject) => {
                return (
                  <option key={subject.moduele_id} value={subject.name}>
                    {subject.name}
                  </option>
                );
              })}
            </Select>
          </Col>
          <Col lg={6} sm={12} className="my-1">
            {selectedModule === "Others" ? (
              <div>
                <SecBTN
                  className="sec-btn1 w-5"
                  onClick={isRecording ? stopRecording : startRecording}
                >
                  <FontAwesomeIcon
                    icon={isRecording ? faStop : faMicrophone} // Toggle between microphone and stop icon
                    size="1x" // Set the size of the icon
                    style={{ color: isRecording ? 'white' : 'white' }} // Change color based on recording state
                  />
                </SecBTN>


                {isRecording && <p>Recording: {formatTime(seconds)}</p>}
              </div>
            ) : (
              <Select
                value={selectedtopic}
                onChange={(e) => topicHandler(e.target.value)}
              >
                <option value="" disabled>Select Topic</option>
                {selectedModule && topicList?.map((topic) => (
                  <option key={topic.topic_id} value={topic.topic_name}>
                    {topic.topic_name}
                  </option>
                ))}
              </Select>
            )}
          </Col>
          <Col lg={6} sm={12} className="my-1">
      {selectedModule !== "DPP" && selectedModule !== "Others" && (
     <>
      {selectedModule === "Module/Exercise" ? (
        <Select
          value={selectedExercise}
          onChange={(e) => {
            exerciseHandler(e.target.value); // Custom handler for exercises
          }}
        >
          <option value="" disabled>
            Select Exercises
          </option>
          {dppExercise?.map((exercise) => (
            <option key={exercise.excersie_type} value={exercise.excersie_type}>
              {exercise.excersie_type}
            </option>
          ))}
        </Select>
      ) : (
        <Select
          value={selectedSubTopic}
          onChange={(e) => {
            subTopicHandler(e.target.value); 
          }}
        >
          <option value="" disabled>
            Select SubTopic
          </option>
          {subTopicList && subTopicList.map((subtopic) => (
            <option
              key={subtopic.sub_topic_id}
              value={subtopic.sub_topic_name}
            >
              {subtopic.sub_topic_name}
            </option>
          ))}
        </Select>
      )}
    </>
  )}
</Col>

          {selectedModule === "Quiz Master" &&
            <Col lg={6} md={6} sm={12} className="my-1">
              <Select
                value={toughness}
                onChange={(e) => {
                  Toughnesshandler(e.target.value)
                  // getTopicList(e.target.value);
                }}
              >
                <option value="" disabled>
                  Select Toughness
                </option>
                {selectedToughness.map((subject) => {
                  return (
                    <option key={subject.toughness_id} value={subject.toughness}>
                      {subject.toughness}
                    </option>
                  );
                })}
              </Select>
            </Col>
          }
          <Col lg={12} sm={12} className="my-1">
            {(selectedSubTopic || selectedModule == "DPP") &&
              <>
                <Input
                  type="text"
                  placeholder="Enter question number range (e.g., 1-5)"
                  value={questionRange}
                  onChange={handleRangeChange}
                  onKeyDown={handleKeyDown}
                />
                <div className='range-container'>
                  {rangelist.map((listitem, index) =>

                    listitem ? (
                      <div key={index} className='listitem-container'>
                        <p>{listitem[0] + "-" + listitem[1]}<span onClick={() => handleRemoveRange(index)} // Call remove handler
                          style={{ cursor: 'pointer', marginLeft: '5px', color: 'red' }} className='remove-question'>X</span></p>
                        <span className='notification'>{parseInt(listitem[1]) - parseInt(listitem[0])}Q</span>
                      </div>
                    ) : null
                  )}

                  {/* {inputRange.length > 0 ? (
                    <div className='listitem-container'>
                      <p>{inputRange}</p>
                      <span className='notification'>{parseInt(inputRange.split("-")[1])-parseInt(inputRange.split("-")[0])}Q</span>
                    </div>
                  ) : null} */}
                </div>

              </>
            }



            {(selectedModule == "Others") &&
              <Input type="text" placeholder="Enter question Description" />
            }

          </Col>
        </Row>

      </Card>

      {selectedModule !== "DPP" && selectedModule !== "Module/Exercise" && selectedtopic && selectedSubTopic && (
        <QuestionsCard
          questionsData={homeworkquestions}
          module_type={selectedModule}
          questionRange={inputRange}
          uncheckRange={uncheckRange}
          savedData={{ facultyId, topicId, subtoicId, batch, subjectId, rangelist }} />
      )}
      {selectedModule === "DPP" && selectedtopic && (
        <QuestionsCard questionsData={homeworkquestions}
          module_type={"DPP"}
          questionRange={inputRange}
          uncheckRange={uncheckRange}
          savedData={{ facultyId, topicId, subtoicId, batch, subjectId, rangelist }} />
      )}

      {selectedModule === "Module/Exercise" && selectedtopic && selectedExercise && (
        <QuestionsCard questionsData={homeworkquestions}
          module_type={"ModuleExercise"}
          questionRange={inputRange}
          uncheckRange={uncheckRange}
          savedData={{ facultyId, topicId, subtoicId, batch, subjectId, rangelist }} />
      )}


      {
        (selectedSubTopic || selectedExercise ) || selectedModule === "DPP" ? " " :
          <div className='action-btns'>
            <SecBTN className={`${classes1.activate} sec-btn preview-btn`}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top of the page smoothly
                HandlePreview(); // Call the preview handler if there's any additional logic
              }}>
              Preview
            </SecBTN>
            <SecBTN className={`${classes1.activate} save-btn`} disabled={true} onClick={""}>Save</SecBTN>
          </div>

      }

    </>
  )
}
